import React, { useState } from 'react';
import { ChatProvider } from '../../context/chat/chat.context';
import { Header } from '../../components/chat/Header';
import { WelcomeScreen } from '../../components/chat/WelcomeScreen';
import { MessageList } from '../../components/chat/MessageList';
import { MessageInput } from '../../components/chat/MessageInput';
import { useChatContext } from '../../context/chat/chat.context';

const ChatContent: React.FC = () => {
  const { messages, buttons, enabledInput, isTyping, handleChatSubmit, selectButtons, setEnabledInput } =
    useChatContext();

  const [chatStarted, setChatStarted] = useState(messages.length > 0);

  const handleSubmit = (message: string) => {
    setChatStarted(true);
    if (buttons.length > 0) {
      handleChatSubmit(buttons.join(', '));
    } else {
      handleChatSubmit(message);
    }
  };

  return (
    <div className="flex flex-col h-screen bg-grey-94">
      <Header />
      {!chatStarted ? (
        <WelcomeScreen />
      ) : (
        <MessageList
          messages={messages}
          isTyping={isTyping}
          selectButtons={selectButtons}
          setEnabledInput={setEnabledInput}
        />
      )}
      <MessageInput onSubmit={handleSubmit} textareaDisabled={!enabledInput} />
    </div>
  );
};

export const ChatPage: React.FC = () => (
  <ChatProvider>
    <ChatContent />
  </ChatProvider>
);
